// app : dead events - events with no instrinctive value
// page : user navigational events - page views
// Action : user specific actions - important.
export type ThirdPartyEventType =
  | 'page_show'
  | 'action_assistance_accepted'
  | 'page_register'
  | 'app_registration_complete'
  | 'page_registration_step'
  | 'page_login'
  | 'action_call_me_back'
  | 'action_call_us_now'
  | 'action_assistance_call_us'
  | 'action_itc_chat_to_us'
  | 'action_quote_reviewed_waiting_to_accept'
  | 'action_quote_reviewed_waiting_on_quotes'
  | 'app_login_complete'
  | 'action_quote_chosen'
  | 'action_quote_banking_details_completed'
  | 'page_wallet'
  | 'page_wallet_details'
  | 'page_premium_comparison'
  | 'page_essential_cover_comparison'
  | 'page_convenience_cover_comparison'
  | 'page_excess_comparison'
  | 'page_optional_cover'
  | 'page_special_conditions'
  | 'action_fna_completed'
  | 'business_quote_request_failed'
  | 'business_endorsement_request_failed'
  | 'business_king_price_user_activate_successful'
  | 'business_king_price_user_already_activated_error'
  | 'business_king_price_general_error'
  | 'action_quote_accepted'
  | 'business_discount_possible'
  | 'action_agreed_itc_check'
  | 'action_sent_friend_referral'
  | 'action_renewal_accepted'
  | 'action_popia_consent_given'
  | 'action_holiday_period_cover_selected'
  | 'action_mandated_quote_selected'
  | 'action_start_new_quote'
  | 'action_quote_requested'
  | 'action_quote_step'
  | 'action_asset_completed'
  | 'action_compare_quote'
  | 'action_asset'
  | 'action_asset_deleted'
  | 'action_endorsement'
  | 'action_endorsement_asset'
  | 'app_personal_details_completed'
  | 'action_endorsement_add_submitted'
  | 'action_endorsement_update_submitted'
  | 'action_endorsement_update_accepted'
  | 'action_endorsement_update_declined'
  | 'action_endorsement_add_accepted'
  | 'action_endorsement_add_declined'
  | 'action_endorsement_add_started'
  | 'action_endorsement_delete'
  | 'action_endorsement_update_started'
  | 'action_forgot_password';
